export enum Groups {
  Courses = "Kurse",
  Meditations = "Meditationen",
  Contributor = "Mitwirkende",
  Content = "Inhalte",
  Verwaltung = "Verwaltung",
  Werkzeuge = "Werkzeuge",
  Other = "Anderes",
}
